import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import classNames from 'classnames';

import Page from '../../../page.jsx';
import partnerPropTypes from '../../../partnerPropTypes.js';
import formatOreToKroner from '../../../../lib/formatOreToKroner.js';
import paymentPropTypes, {
    data as paymentDataPropTypes,
} from '../../../paymentPropTypes.js';
import { approveDiscount } from '../../payment/paymentActions.js';

const DiscountSuggestedByBuyerDetails = ({
    handleClickApproveDiscount,
    partner,
    payment,
}) => (
    <Page heading={`${partner.name} foreslår et prisavslag`}>
        <div>
            <p>Varen er ikke som {partner.name} forventet.</p>
            <p className="r-pbl">
                {partner.name} foreslår et prisavslag på{' '}
                {formatOreToKroner(payment.data.discount)}. Hvis du godtar
                forslaget, får du {formatOreToKroner(payment.data.amount)} for
                varen og {formatOreToKroner(payment.data.freight)} for frakt.
            </p>

            <div className="centerify r-phl r-ptl">
                <button
                    disabled={payment.loading}
                    className={classNames('primary fullwidth r-mbm', {
                        inprogress: payment.loading,
                    })}
                    onClick={handleClickApproveDiscount}
                >
                    Godta prisavslag
                </button>

                <div className="r-mvl">
                    <Link to="/losning/foresla-losning" className="pam">
                        Foreslå en annen løsning
                    </Link>
                </div>
            </div>
        </div>
    </Page>
);

DiscountSuggestedByBuyerDetails.propTypes = {
    handleClickApproveDiscount: PropTypes.func.isRequired,
    partner: partnerPropTypes.isRequired,
    payment: paymentPropTypes.isRequired,
};

const DiscountSuggestedBySellerDetails = ({ partner, payment }) => (
    <Page heading={`Venter på svar fra ${partner.name}`}>
        <div>
            <p>
                Du har foreslått et avslag på{' '}
                {formatOreToKroner(payment.discount)}. Hvis {partner.name} godtar
                avslaget, får du {formatOreToKroner(payment.amount)} for varen
                og {formatOreToKroner(payment.freight)} for frakt.
            </p>

            <div className="r-phl r-ptl">
                <Link to="/samtale" className="button fullwidth">
                    OK
                </Link>
            </div>
        </div>
    </Page>
);

DiscountSuggestedBySellerDetails.propTypes = {
    partner: partnerPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
};

const DiscountSuggestedDetails = ({
    partner,
    payment,
    handleClickApproveDiscount,
}) => {
    if (payment.data.performedBy === 'BUYER') {
        return (
            <DiscountSuggestedByBuyerDetails
                handleClickApproveDiscount={handleClickApproveDiscount}
                partner={partner}
                payment={payment}
            />
        );
    } else {
        return (
            <DiscountSuggestedBySellerDetails
                partner={partner}
                payment={payment.data}
            />
        );
    }
};

DiscountSuggestedDetails.propTypes = {
    handleClickApproveDiscount: PropTypes.func.isRequired,
    itemId: PropTypes.string.isRequired,
    itemType: PropTypes.string.isRequired,
    partner: partnerPropTypes.isRequired,
    payment: paymentPropTypes.isRequired,
};

function mapStateToProps(state) {
    return {
        itemId: state.safeTrade.itemId,
        itemType: state.safeTrade.itemType,
        partner: state.partner,
        payment: state.payment,
    };
}

const mapDispatchToProps = { handleClickApproveDiscount: approveDiscount };

function mergeProps(stateProps, dispatchProps, ownProps) {
    const { itemType, itemId, partner } = stateProps;

    return {
        ...ownProps,
        ...stateProps,
        handleClickApproveDiscount: () =>
            dispatchProps.handleClickApproveDiscount({
                itemType,
                itemId,
                partnerId: partner.id,
            }),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(
    DiscountSuggestedDetails
);



// WEBPACK FOOTER //
// ./safeTrade/seller/resolution/statusDetails/discountSuggestedDetails.jsx